"use strict";

var _interopRequireDefault = require("reshow-runtime/helpers/interopRequireDefault");
var _interopRequireWildcard = require("reshow-runtime/helpers/interopRequireWildcard");
exports.__esModule = true;
exports["default"] = void 0;
var _objectSpread2 = _interopRequireDefault(require("reshow-runtime/helpers/objectSpread2"));
var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("reshow-runtime/helpers/objectWithoutPropertiesLoose"));
var React = _interopRequireWildcard(require("react"));
var _classLib = require("class-lib");
var _SemanticUI = _interopRequireDefault(require("../molecules/SemanticUI.js"));
var _jsxRuntime = require("react/jsx-runtime");
var _excluded = ["type", "className", "children", "horizontal"]; // @ts-check
var Children = React.Children,
  cloneElement = React.cloneElement;

/**
 * @param {React.ReactElement} children
 * @param {string} pAtom
 * @param {boolean} horizontal
 * @returns {any[]}
 */
var renderChildren = function renderChildren(children, pAtom, horizontal) {
  return Children.map(children, function (child) {
    if (!child) {
      return null;
    }
    if ("ul" === pAtom || "ol" === pAtom) {
      child = cloneElement(child, {
        atom: "li"
      });
    } else if ("table" === pAtom) {
      child = cloneElement(child, {
        atom: "td"
      });
      if (!horizontal) {
        child = /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
          children: child
        });
      }
    }
    return child;
  });
};

/**
 * @param {{className?: string, [key: string]: any}} props
 */
var List = function List(props) {
  /**
   * Why need type?
   *
   * List not the only type, such as segments.
   * https://semantic-ui.com/elements/segment.html#raised-segments
   *
   */
  var _props$type = props.type,
    type = _props$type === void 0 ? "list" : _props$type,
    className = props.className,
    children = props.children,
    horizontal = props.horizontal,
    restProps = (0, _objectWithoutPropertiesLoose2["default"])(props, _excluded);
  var atom = props.atom;
  var classes = (0, _classLib.mixClass)(className, type, {
    horizontal: horizontal
  });
  /**
   * @type {any}
   */
  var child = renderChildren(children, atom, horizontal);
  if (atom === "table") {
    if (child) {
      if (horizontal) {
        child = /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
          children: /*#__PURE__*/(0, _jsxRuntime.jsx)("tr", {
            children: child
          })
        });
      } else {
        child = /*#__PURE__*/(0, _jsxRuntime.jsx)("tbody", {
          children: child
        });
      }
    }
  }
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_SemanticUI["default"], (0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, restProps), {}, {
    cssList: [{
      cssModule: ["list"],
      cssGroup: "semantic"
    }],
    className: classes,
    children: child
  }));
};
var _default = exports["default"] = List;
module.exports = exports.default;